import { Navigate, Route, Routes } from 'react-router-dom'
import { useAdminAuth } from './context/AdminAuthContext'
import AdminLayout from './components/AdminLayout'
import { Spinner } from './components/ui'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Tenants from './pages/Tenants'
import Revendas from './pages/Revendas'
import Notifications from './pages/Notifications'
import Monitoring from './pages/Monitoring'
import Prices from './pages/Prices'
import Billing from './pages/Billing'
import Admins from './pages/Admins'
import Profile from './pages/Profile'
import Mavi from './pages/Mavi'
import TenantForm from './pages/TenantForm'
import RevendaForm from './pages/RevendaForm'
import NotificationForm from './pages/NotificationForm'
import PriceForm from './pages/PriceForm'
import AdminForm from './pages/AdminForm'
import MaviFeedback from './pages/MaviFeedback'
import LoginSecurity from './pages/LoginSecurity'

function PrivateRoute({ children, masterOnly, superOnly }) {
  const { isAuthenticated, loading, isMaster, isSuperAdmin } = useAdminAuth()

  if (loading) return <Spinner />
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (masterOnly && !isMaster) return <Navigate to="/" replace />
  if (superOnly && !isSuperAdmin) return <Navigate to="/" replace />

  return children
}

export default function App() {
  const { isAuthenticated, loading } = useAdminAuth()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />
      <Route
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="tenants/new" element={<TenantForm />} />
        <Route path="tenants/:id/edit" element={<TenantForm />} />
        <Route
          path="revendas"
          element={
            <PrivateRoute masterOnly>
              <Revendas />
            </PrivateRoute>
          }
        />
        <Route
          path="revendas/new"
          element={
            <PrivateRoute masterOnly>
              <RevendaForm />
            </PrivateRoute>
          }
        />
        <Route
          path="notifications"
          element={
            <PrivateRoute masterOnly>
              <Notifications />
            </PrivateRoute>
          }
        />
        <Route
          path="notifications/new"
          element={
            <PrivateRoute masterOnly>
              <NotificationForm />
            </PrivateRoute>
          }
        />
        <Route
          path="notifications/:id/edit"
          element={
            <PrivateRoute masterOnly>
              <NotificationForm />
            </PrivateRoute>
          }
        />
        <Route
          path="monitoring"
          element={
            <PrivateRoute masterOnly>
              <Monitoring />
            </PrivateRoute>
          }
        />
        <Route
          path="mavi"
          element={
            <PrivateRoute masterOnly>
              <Mavi />
            </PrivateRoute>
          }
        />
        <Route
          path="mavi/feedback/:id"
          element={
            <PrivateRoute masterOnly>
              <MaviFeedback />
            </PrivateRoute>
          }
        />
        <Route
          path="prices"
          element={
            <PrivateRoute masterOnly>
              <Prices />
            </PrivateRoute>
          }
        />
        <Route
          path="prices/new"
          element={
            <PrivateRoute masterOnly>
              <PriceForm />
            </PrivateRoute>
          }
        />
        <Route
          path="prices/:id/edit"
          element={
            <PrivateRoute masterOnly>
              <PriceForm />
            </PrivateRoute>
          }
        />
        <Route
          path="billing"
          element={
            <PrivateRoute masterOnly>
              <Billing />
            </PrivateRoute>
          }
        />
        <Route
          path="security/login-blocks"
          element={
            <PrivateRoute superOnly>
              <LoginSecurity />
            </PrivateRoute>
          }
        />
        <Route
          path="admins"
          element={
            <PrivateRoute superOnly>
              <Admins />
            </PrivateRoute>
          }
        />
        <Route
          path="admins/new"
          element={
            <PrivateRoute superOnly>
              <AdminForm />
            </PrivateRoute>
          }
        />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
